import { useEffect, useRef, useState } from "react";
import { C, FONT, card, commas } from "../theme";
import type { Kpi as KpiType } from "../types";

const easeOutCubic = (t: number) => 1 - (1 - t) ** 3;

export function Kpi({ kpi }: { kpi: KpiType }) {
  const isNum = typeof kpi.value === "number";
  const target = isNum ? (kpi.value as number) : 0;
  const [n, setN] = useState(0);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isNum) return;
    const start = performance.now();
    const dur = 950;
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / dur);
      setN(Math.round(target * easeOutCubic(t)));
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
    };
  }, [isNum, target]);

  const display = isNum ? commas(n) : (kpi.value as string);

  return (
    <div style={{ ...card, padding: "20px 20px 18px" }}>
      <div className="eyebrow">{kpi.label}</div>
      <div style={{ display: "flex", alignItems: "baseline", gap: 5, marginTop: 13 }}>
        <span
          className="serif tnum"
          style={{
            fontFamily: FONT.serif,
            fontSize: 38,
            fontWeight: 400,
            lineHeight: 0.9,
            color: kpi.accent || C.ink,
          }}
        >
          {display}
        </span>
        {kpi.unit && <span style={{ color: C.muted, fontSize: 14 }}>{kpi.unit}</span>}
      </div>
      <div style={{ marginTop: 9, fontSize: 12.5, color: C.textMid }}>{kpi.sub}</div>
    </div>
  );
}
